import { render } from "./form.vue?vue&type=template&id=ca4f5e58&scoped=true"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"

import "./form.vue?vue&type=style&index=0&id=ca4f5e58&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ca4f5e58"

export default script